// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const froakie: PokeData = {
  "id": 656,
  "name": "froakie",
  "height": 3,
  "weight": 70,
  "base_experience": 63,
  "types": [
    PokeType.WATER
  ],
  "api_moves": [
    "pound",
    "growl",
    "water-gun",
    "hydro-pump",
    "quick-attack",
    "double-team",
    "smokescreen",
    "lick",
    "bubble",
    "substitute",
    "bounce",
    "water-pulse",
    "fling",
    "smack-down",
    "round"
  ],
  "moves": [
    "growl",
    "hydro-pump",
    "quick-attack",
    "lick",
    "bubble",
    "life-dew",
    "aqua-cutter",
    "brine",
    "liquidation",
    "aqua-tail",
    "aqua-jet",
    "rain-dance",
    "water-spout"
  ],
  "evolution_chain": {
    "id": 339,
    "item": null,
    "species": [
      {
        "name": "froakie",
        "order": 657,
        "types": [
          PokeType.WATER
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "frogadier",
        "order": 658,
        "types": [
          PokeType.WATER
        ],
        "evolves_from_species_id": 656,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 16,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      },
      {
        "name": "greninja",
        "order": 659,
        "types": [
          PokeType.WATER,
          PokeType.DARK
        ],
        "evolves_from_species_id": 657,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 36,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 41.5,
    "speed": 71,
    "ability_power": 62
  },
  "stat_changes": [],
  "catch_rate": 45,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
